<template>
  <div class="serviceList">
    <div class="serviceMain">
      <div class="infosearch">
        <span class="labelTit">会员手机号</span>
        <el-input v-model="memPhone" placeholder="输入会员手机号" style="width: 220px;margin-right: 10px"></el-input>
        <span class="labelTit">订单类型</span>
        <el-select v-model="orderType" placeholder="请选择类型" style="width:120px;margin-right: 10px">
          <el-option label="全部" value></el-option>
          <el-option label="线上订单" value="1"></el-option>
          <el-option label="门店订单" value="2"></el-option>
        </el-select>
        <span class="labelTit">提交日期</span>
        <el-date-picker
          v-model="orderTime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
          value-format="timestamp"
          style="width: 260px;margin-right: 10px"
        ></el-date-picker>        
        <el-button
          class="searchBtn"
          @click="search(1)"
          v-loading.fullscreen.lock="fullscreenLoading"
        ></el-button>
      </div>
      <el-table
        v-if="tableData.length > 0"
        :data="tableData"
        :height="tableData.length < 10 ? '615':'auto'"
        ref="multipleTable"
        :cell-class-name="tableRowClassName"
        @cell-click="linkTo"
        class="myMemTable"
        style="width: 100%"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="memberId" label="退货单号"></el-table-column>
        <el-table-column align="center" prop="relationId" label="关联订单"></el-table-column>
        <el-table-column align="center" prop="phone" label="订单类型"></el-table-column>
        <el-table-column align="center" prop="source" label="会员姓名">
          <template slot-scope="scope">{{scope.row.source | filterSource | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="手机号">
          <template slot-scope="scope">{{scope.row.createTime | formatDate | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="accountOff" label="项目"></el-table-column>
        <el-table-column align="center" prop="consumedOff" label="已用数量"></el-table-column>
        <el-table-column align="center" prop="consumedOff" label="剩余次数"></el-table-column>
        <el-table-column align="center" prop="consumedOff" label="提交时间"></el-table-column>
        <el-table-column align="center" prop="consumedOff" label="退款金额"></el-table-column>
        <el-table-column align="center" prop="status" label="状态"></el-table-column>
        <el-table-column align="center" label="操作" class-name="operation">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 1">
              <el-button size="mini" type="danger" @click="toCancel()">取消</el-button>
            </template>
            <template v-else-if="scope.row.status == 2">
              <el-button size="mini" @click="toView()">查看</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到退货单信息！再核对一下试试</div>
      </template>

      <el-pagination
        v-show="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px;text-align:right"
      ></el-pagination>
    </div>

    <el-dialog title="退货单" :visible.sync="dialogTableVisible" :center="true" width="580px">
      <!-- 退货单 -->
      <refused :relationFlag='true' :physicalFlag='true' @closeDialog="closeDialog" />
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import { searchMem } from "@/api";
import refused from "./refused";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}
const myData = [];
for (let i = 0; i < 20; i++) {
  myData.push({
    memberId: i,
    status: i
  });
}

export default {
  components: {
    refused
  },
  data() {
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      memPhone: "",
      orderTime: "",
      orderType:'',
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      mySearchflag: false,
      fullscreenLoading: false,
      dialogTableVisible:false,
    };
  },
  created() {
    this.search();
  },
  methods: {
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.currentPage = 1;
      }
      //   let res = await searchMem({
      //     keyword: this.memPhone,
      //     pageSize: this.pageSize,
      //     pageNumber: this.currentPage
      //   });
      this.fullscreenLoading = false;
      if (myData.length == 0) {
        this.mySearchflag = true;
      }
      this.total = 20;
      this.tableData = myData;
    },
    linkTo(row, column) {
      // 详情
      if(column.property == 'memberId'){
          this.dialogTableVisible = true;
      }else if(column.property == 'relationId'){
        this.$router.push("/financeManageCenter/orderDetail" + row.relationId);
      }
    },
    toCancel(){
      // 取消
      this.$alert(
        "<h2>提示</h2><p>确定要取消退货？</p>",
        "",
        {
          dangerouslyUseHTMLString: true,
          customClass: "memBox",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "不取消了",
          cancelButtonClass: "darkBtn",
          confirmButtonClass: "redBtn",
          closeOnClickModal: true
        }
      )
        .then(({ value }) => {
          // 点击确定时，再次判断一下该退货单的状态是否依然是“未审核”状态。若是，则toast提示取消成功！若非“未审核”状态，则toast提示“取消失败，请刷新列表后再操作”。
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "不取消了"
          });
        });
    },
    toView() {
      //   查看
      this.dialogTableVisible = true;
    },
    closeDialog(val) {
      this.dialogTableVisible = val;
    }
  }
};
</script>
<style lang="less" scoped>
.serviceMain {
  padding: 25px 0;
  .labelTit {
    color: #666;
    margin-right: 5px;
  }
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.serviceList {
  .el-dialog__title {
    font-weight: bold;
  }
}
.serviceMain {
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/businessManagementCenter/returnList.vue